var React = require('react');

var Tabs = require('react-bootstrap/lib/Tabs');
var Tab = require('react-bootstrap/lib/Tab');
import Iframe from 'react-iframe'

var Financial = React.createClass({

	componentWillMount: function() {
	},

	componentWillUnmount: function() {
	},

	render: function() {
		var me = this;

		return (
			<Tabs
				animation={false}
				defaultActiveKey={1} 
				id="requests_filters">
				
				<Tab eventKey={1} title="Cliente">
					<Iframe style={{width:'50%', height:'100px'}} url={"https://www.avamobile.com.br/api/ajato-financial/clients.html"}
				        allowFullScreen/>
				</Tab>
				<Tab eventKey={2} title="Entregador">
					<Iframe url={"https://www.avamobile.com.br/api/ajato-financial/couriers.html"}
				        allowFullScreen/>
				</Tab>
				<Tab eventKey={3} title="Movimentação">
					<Iframe url={"https://www.avamobile.com.br/api/ajato-financial/result.html"}
				        allowFullScreen/>
				</Tab>
			</Tabs>
		);
	}

});

module.exports = Financial;


// WEBPACK FOOTER //
// ./src/components/Admin/Financial/Financial.jsx